import { render, staticRenderFns } from "./CsCenterHeader.vue?vue&type=template&id=70cfc374&scoped=true&"
import script from "./CsCenterHeader.vue?vue&type=script&lang=js&"
export * from "./CsCenterHeader.vue?vue&type=script&lang=js&"
import style0 from "./CsCenterHeader.vue?vue&type=style&index=0&id=70cfc374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfc374",
  null
  
)

export default component.exports